import React from 'react';
import Footer from '../components/Footer';

const Portfolio = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-5xl mx-auto">
            <h1 className="text-5xl font-bold text-black mb-12 text-center opacity-0 animate-fade-in-up">PORTFOLIO</h1>
            <p className="text-xl text-gray-700 leading-relaxed mb-12 text-center opacity-0 animate-fade-in-up delay-200">
              At Imperier Holdings, we partner with visionary founders to build scalable, future-ready businesses. Our portfolio reflects a diversified approach across high-growth sectors, with a focus on long-term value creation, strategic guidance, and responsible exits.
            </p>
            <div className="flex justify-center opacity-0 animate-fade-in-up delay-300">
              <img
                src="https://res.cloudinary.com/ditcmszc1/image/upload/v1769763274/WhatsApp_Image_2026-01-03_at_2.30.45_PM_ukttl7_gg5uuf.jpg"
                alt="Imperier Holdings Portfolio"
                className="w-full h-auto rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Portfolio;

